import PresortDemo from "../components/table/DataTable";
import { useEffect, useRef, useState } from "react";
import { Sidebar } from "primereact/sidebar";
import "./page.css"
import { partialColumn } from "../metadata/partial";
import { SpeedDial } from "primereact/speeddial";
import MyButton from "../components/UI/Button";
import Editor from "../components/UI/editor";
import { useActionsHook } from "../hooks/useActionsHook";
import { Toast } from 'primereact/toast';
import { useNavigate, useParams } from "react-router-dom";
import { useCreateOrUpdatePartialMutation, useGetPartialQuery } from "../store/api/partialApi";
import { generateTrackingCode } from "./SetUser";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";
import { useGetManifestDataQuery } from "../store/api/orderAPI";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";



function Partial() {
	const { type } = useParams()
	const { data, error, isLoading } = useGetPartialQuery(type);
	const { t } = useTranslation();
	const { auth } = useSelector(state => state.auth);
	const role = auth?.role ?? 'Админ';
	const partialColumnTr = useTranslatedColumns(partialColumn);
	const navigate = useNavigate();
	const toast = useRef(null);
	const [createOrUpdatePartial] = useCreateOrUpdatePartialMutation();

	const actions = useActionsHook([
		{
			onClick: (param, data) => {
				if (type == 16 || type == 18) {
					navigate("/accept-partial", {
						state: {
							...data
							, partial: true
							, status: type
						}
					})
					return
				}
				if (data?.status == 3 || data?.status == 16) {
					return
				}
				navigate("/partial-detail/" + data.guid, {
					state: {
						typePartial: 18
					}
				})
			},
			icon: "pi pi-eye"
		},
	])
	const items = [
		{
			label: 'React Website',
			icon: 'pi pi-external-link',
			command: () => {
			}
		}
	];

	const [formData, setFormData] = useState({

	});

	const [visibleLeft, setVisibleLeft] = useState({
		visible: false,
		data: null
	});

	function toggleSidebar(bool, data) {
		console.log((role != "Админ") && data?.status == 3 || data?.status == 16 || data?.status == 24);
		if ((role != "Админ")) {
			if (data?.status == 3 || data?.status == 16 || data?.status == 24) {
				return
			}
		}
		setFormData(data)
		setVisibleLeft(state => {
			return {
				visible: bool,
				data: data
			}
		})
	}

	const onBlur = (e, attr, value) => {
		setFormData(state => {
			return {
				...state,
				[attr]: value
			}
		});
	}

	//Убрать объемный вес партии
	//Оправитель должен выдеть данные отправленных партии без возможности редак

	return (<>
		<Toast ref={toast} />
		{/* <p
			style={{
				fontSize: 18,
				fontWeight: 600,
				margin: 8
			}}
		>
			<span> {t("partial")} </span>

		</p> */}
		<PresortDemo
			isLoading={isLoading}
			data={data}
			column={partialColumnTr}
			toggleSidebar={toggleSidebar}
			deleteHandler={(row, field) => {
				console.log(row, field);
			}}
			actions={type == 24 ? [] : actions}
		/>
		<SpeedDial
			model={items}
			radius={120}
			type="quarter-circle"
			onClick={() => {
				toggleSidebar(true, {});
			}}
			direction="up-left"
			style={{ right: 15, bottom: 15 }} />
		<Sidebar visible={visibleLeft.visible} position="right" onHide={() => { toggleSidebar(false) }} style={{ width: "50vw" }}>
			<div className="user-sidebar">
				{!formData?.guid && (
					<div className="inp_button">
						<div
							style={{
								width: "calc(100% - 140px)",
							}}
						>
							<Editor
								label={t("numberPartial")}
								data={formData}
								attr="partial_code"
							/>
						</div>
						<MyButton
							label={t("generateCod")}
							onClick={async () => {
								setFormData((prev) => ({
									...prev,
									partial_code: generateTrackingCode("NPX"),
								}));
							}}
						/>
					</div>
				)}
				<div className="user-sidebar-edit">
					{
						partialColumnTr.filter((i) => i.editor).map(el => {
							return (
								<div>
									<Editor {...el} onBlur={onBlur} data={formData} />
								</div>
							)
						})
					}
					<div></div>
					<MyButton label={t("save")} onClick={async () => {
						await createOrUpdatePartial(formData);
						await console.log(formData);
						toast.current.show({ severity: 'info', summary: 'success', detail: t("successSaved"), life: 3000 });
						toggleSidebar(false)
					}} />
				</div>
			</div>

		</Sidebar>
	</>);
}

export default Partial;